import getConfig from 'next/config';
import { track } from 'lib/index';
import StackTrace from 'stacktrace-js';

const { publicRuntimeConfig } = getConfig();

console.log('publicRuntimeConfig', publicRuntimeConfig);

const { mode, version, isElectron, isLocal, basePath } = publicRuntimeConfig;

const defaultCommonConfig = {
  production: false,
  grey: false,
  staging: false,
  development: false,

  version,

  weixinApi: 'thirdlogin/weixin_pc?app_id={appid}',

  weixinLoginUrl:
    'https://open.weixin.qq.com/connect/qrconnect?appid={appid}&redirect_uri={redirect_uri}&response_type=code&scope=snsapi_login&state=1#wechat_redirect',

  qqApi: 'thirdlogin/qq',
  qqLoginUrl:
    'https://graph.qq.com/oauth2.0/authorize?scope=upload_pic,add_topic,get_user_info&client_id=101118713&response_type=code&redirect_uri={redirect_uri}',

  sinaLoginUrl:
    'https://api.weibo.com/oauth2/authorize?scope=follow_app_official_microblog&client_id=3338801716&display=default&redirect_uri={redirect_uri}&state={state}',
  sinaApi: 'thirdlogin/sina',

  defaultImg: 'https://img.sumeme.com/3/3/1559108259459.png',
  blankImg: 'https://img.sumeme.com/59/3/1452150023355.jpg',

  debug: true,
  [mode!]: true,
  mode,
  isLocal,
  basePath,
  isElectron,
  flvConfig: {
    cache_key: 'MEME_PLAYER_TYPE5',
    is_flv_player: !0,
    room_ids: [],
    flv_options: {
      autoCleanupSourceBuffer: !0,
      autoCleanupMaxBackwardDuration: 30,
      autoCleanupMinBackwardDuration: 20,
      enableWorker: !0,
      lazyLoadMaxDuration: 30,
      seekType: 'range',
      fixAudioTimestampGap: !1,
      isLive: !0,
    },
  },
};

export type DomainType =
  | 'main'
  | 'api'
  | 'user'
  | 'amber'
  | 'ws'
  | 'gs'
  | 'pay'
  | 'lib'
  | 'flint'
  | 'cryolite'
  | 'act'
  | 'game'
  | 'm'
  | 'h5'
  | 'funny'
  | 'hotspots';

const modeConfig = {
  test: {},
  production: {
    wxAppId: 'wxcd8011dbaf7a24ca',
    agoraAppId: 'b33f5757d17e4b9fb2b4979105e319b3',
    zegoAppId: 2999925240,
    domain: {
      main: 'www.2339.com',
      h5: 'h5.2339.com',
      m: 'm.2339.com',
      api: 'api.memeyule.com', // api域名
      user: 'user.memeyule.com',
      amber: 'amber.memeyule.com',
      ws: 'ws.memeyule.com:6110', // 聊天ws域名
      gs: 'gs.memeyule.com:6130', // 游戏
      pay: 'pay.memeyule.com',
      lib: 'lib.sumeme.com',
      flint: 'flint.memeyule.com',
      cryolite: 'cryolite.memeyule.com',
      vc: 'vc-gateway.jycz2024.cn',
      mon: 'mon.memeyule.com',
      game: 'games.memeyule.com',
      act: 'act.2339.com',
      im: 'im.2339.com',
      funny: 'funny.memeyule.com',
      hotspots: 'hotspots.memeyule.com',
    },
  },
  grey: {
    wxAppId: 'wxcd8011dbaf7a24ca',
    agoraAppId: 'b33f5757d17e4b9fb2b4979105e319b3',
    zegoAppId: 2999925240,
    domain: {
      main: 'grey.2339.com',
      m: 'grey-m.2339.com',
      h5: 'grey-h5.2339.com',
      api: 'grey-api.memeyule.com', // api域名
      user: 'grey-user.memeyule.com',
      amber: 'grey-amber.memeyule.com',
      ws: 'grey-ws.memeyule.com:6210', // 聊天ws域名
      gs: 'gs.memeyule.com:6130', // 游戏
      pay: 'grey-pay.memeyule.com',
      lib: 'lib.sumeme.com',
      flint: 'grey-flint.memeyule.com',
      cryolite: 'grey-cryolite.memeyule.com',
      vc: 'grey-vc-gateway.jycz2024.cn',
      mon: 'mon.memeyule.com',
      game: 'grey-games.memeyule.com',
      act: 'grey-act.2339.com',
      im: 'grey-im.2339.com',
      funny: 'grey-funny.memeyule.com',
      hotspots: 'grey-hotspots.memeyule.com',
    },
  },
  staging: {
    wxAppId: 'wx8120ce5a486794d7',
    agoraAppId: '3f574f3c41a94d6098e0a6828fdcfadd',
    zegoAppId: 2999925240,
    domain: {
      main: 'test.2339.com',
      m: 'test-m.2339.com',
      h5: 'test-h5.2339.com',
      // h5: 'http://localhost:9200',
      api: 'test-api.memeyule.com', // api域名
      user: 'test-user.memeyule.com',
      amber: 'test-amber.memeyule.com',
      // ws: 'http://localhost:6010', //聊天ws域名
      // ws: 'http://test-ws.jycz2024.cn:6040',
      // ws: 'test-ws.jycz2024.cn:6140',
      // ws: 'http://test-ws.memeyule.com:6010', // 聊天ws域名
      ws: 'test-ws.memeyule.com:6110', // 聊天ws域名
      gs: 'test-play-ws.memeyule.com:6130', // 游戏
      pay: 'test-pay.memeyule.com',
      lib: 'test-lib.sumeme.com',
      flint: 'test-flint.memeyule.com',
      cryolite: 'test-cryolite.memeyule.com',
      vc: 'test-vc-gateway.jycz2024.cn',
      mon: 'test-mon.memeyule.com',
      game: 'test-games.memeyule.com',
      // game: 'http://localhost:9201',
      act: 'test-act.2339.com',
      // act: 'http://192.168.11.67:9100',
      im: 'test-im.2339.com',
      funny: 'test-funny.memeyule.com',
      hotspots: 'test-hotspots.memeyule.com',
    },
  },
  development: {
    wxAppId: 'wx8120ce5a486794d7',
    agoraAppId: '3f574f3c41a94d6098e0a6828fdcfadd',
    zegoAppId: 2999925240,
    domain: {
      main: 'dev.2339.com',
      // main: 'http://192.168.11.67:9400',
      m: 'dev-m.2339.com',
      h5: 'dev-h5.2339.com',
      api: 'dev-api.memeyule.com', // api域名
      user: 'dev-user.memeyule.com',
      amber: 'dev-amber.memeyule.com',
      ws: 'dev-ws.memeyule.com:6110', // 聊天ws域名
      // ws: 'http://localhost:6010',//聊天ws域名
      gs: 'test-play-ws.memeyule.com:6130', // 游戏
      pay: 'dev-pay.memeyule.com',
      lib: 'test-lib.sumeme.com',
      flint: 'test-flint.memeyule.com',
      // cryolite: 'test-cryolite.memeyule.com',
      cryolite: 'dev-cryolite.memeyule.com',
      vc: 'test-vc-gateway.jycz2024.cn',
      mon: 'mon.memeyule.com',
      game: 'test-games.memeyule.com',
      // act: 'localhost:9100',
      act: 'dev-act.2339.com',
      im: 'dev-im.2339.com',
      funny: 'dev-funny.memeyule.com',
      hotspots: 'test-hotspots.memeyule.com',
    },
  },
};

const config = Object.assign(defaultCommonConfig, modeConfig[mode!]);

console.log('[CONFIG] mode', mode);
if (typeof window !== 'undefined') {
  window.CURRENT_CONFIG = config;

  window.addEventListener('unhandledrejection', (event) => {
    console.error('unhandledrejection', event);
  });

  window.addEventListener('error', (event) => {
    console.error('error', event);
    StackTrace.fromError(event.error)
      .then((stackFrames) => {
        track.send({
          event: 'pageError',
          event_type: 'windowError',
          content: {
            ...event,
          },
          stackFrames,
        });
      })
      .catch((catchError) => {
        track.send({
          event: 'pageError',
          event_type: 'windowErrorCatch',
          content: {
            ...event,
            catchError,
          },
        });
      });
  });
}

export default config;
